import { authApi } from '../api/authApi';
import { invalidateCsrfToken } from '../api/csrf';
import { AUTH_RETURN_TO_STORAGE_KEY } from './authNavigation';
import { resetAccountApiState } from './accountApiState';
import { resetDonates } from '../slices/donatesSlice';
import {
  logoutFailed,
  logoutStarted,
  logoutSucceeded
} from '../slices/authSlice';
import { resetCategoryPreview } from '../slices/rouletteSlice';
import { disconnectSockets, SOCKET_SCOPES } from '../slices/socketReducer';

const LEGACY_AUTH_STORAGE_KEY = 'auth';

const getBrowserStorage = (storageName) => {
  try {
    return typeof window === 'undefined' ? null : window[storageName];
  } catch {
    return null;
  }
};

const normalizeLogoutError = (error) => {
  if (error?.status === 'FETCH_ERROR' || error?.status === 'TIMEOUT_ERROR') {
    return { type: 'logout_network', status: null };
  }
  if (typeof error?.status === 'number') {
    return { type: 'logout_server', status: error.status };
  }
  return { type: 'logout_unexpected', status: null };
};

export const clearAuthTransientStorage = ({
  local = getBrowserStorage('localStorage'),
  session = getBrowserStorage('sessionStorage')
} = {}) => {
  try {
    local?.removeItem(LEGACY_AUTH_STORAGE_KEY);
  } catch {
    // Logout remains valid when browser storage is unavailable.
  }

  try {
    session?.removeItem(AUTH_RETURN_TO_STORAGE_KEY);
  } catch {
    // Logout remains valid when browser storage is unavailable.
  }
};

const resetPrivateState = async (dispatch) => {
  await dispatch(resetAccountApiState());
  dispatch(resetDonates());
  dispatch(resetCategoryPreview());
  clearAuthTransientStorage();
};

export const logoutCurrentSession = ({ logoutRequest } = {}) => async (dispatch) => {
  dispatch(logoutStarted());
  await dispatch(disconnectSockets(SOCKET_SCOPES.ACCOUNT));

  try {
    if (logoutRequest) {
      await logoutRequest();
    } else {
      await dispatch(authApi.endpoints.logout.initiate()).unwrap();
    }

    await resetPrivateState(dispatch);
    dispatch(logoutSucceeded());
    return { serverInvalidated: true };
  } catch (error) {
    // A rejected logout may have used an expired token. Force a fresh CSRF
    // bootstrap when the user retries server-side invalidation.
    invalidateCsrfToken();
    await resetPrivateState(dispatch);
    dispatch(logoutFailed(normalizeLogoutError(error)));
    return { serverInvalidated: false };
  }
};

export const applyRemoteLogout = () => async (dispatch) => {
  dispatch(logoutStarted());
  await dispatch(disconnectSockets(SOCKET_SCOPES.ACCOUNT));
  await resetPrivateState(dispatch);
  dispatch(logoutSucceeded());
};
